<template>
  <v-hover v-slot="{ hover }">
    <v-card outlined :elevation="hover ? 4 : 1" @click="versAssociation">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title
            style="text-overflow: none !important; white-space: wrap !important"
          >
            <strong>{{ association.nom }}</strong>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <a-association-etat-chip :etat="association.etat" />
        </v-list-item-icon>
      </v-list-item>
      <v-card-text>
        <div>
          Référence de l'association (N° AMALIA) :&nbsp;
          <span data-testid="association-numero">{{ association.numero }}</span>
        </div>
        <div>Siège : {{ association.codePostal }} - {{ association.commune }}</div>
      </v-card-text>
      <v-card-actions style="height:52px; !important">
        <template v-if="invitation">
          <v-hover v-slot="{ hover }">
            <v-btn
              block
              :outlined="hover"
              depressed
              color="secondary"
              @click.stop="procedureRattachement"
              data-testid="repondre-invitation"
            >
              Répondre à l'invitation
            </v-btn>
          </v-hover>

          <v-dialog v-if="invitation" v-model="dialogInvitation" width="600px">
            <v-card>
              <v-card-title> Répondre à l'invitation</v-card-title>
              <v-card-text>
                <p>
                  Une procédure de rattachement concernant l'association a été initialisée
                  par
                  {{ labelDemandeur }}.
                </p>
                <p>
                  Le rattachement à cette association aura pour conséquences de vous
                  permettre de :
                </p>
                <ul>
                  <li>consulter l'intégralité des informations liées à l'association</li>
                  <li v-if="depot">
                    créer, déposer et suivre de manière dématérialisée toutes les demandes
                    (requêtes) relatives à la vie de l'association (modification de
                    direction ou de statuts, dissolution...)
                  </li>
                  <li v-if="gestion">
                    créer, gérer et supprimer les droits des personnes rattachées à
                    l'association
                  </li>
                </ul>
                <p class="mt-1">Acceptez-vous le rattachement à l'association ?</p>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="primary"
                  :loading="validation"
                  @click="validationInvitation(true)"
                  data-testid="accepter-rattachement"
                >
                  Oui
                </v-btn>
                <v-btn
                  :loading="validation"
                  @click="validationInvitation(false)"
                  color="error"
                  data-testid="refuser-rattachement"
                >
                  Non
                </v-btn>
                <v-spacer />
                <v-btn data-testid="fermer" @click="dialogInvitation = false"> Fermer </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </v-card-actions>
      <v-divider class="mt-1 mb-1" />
      <v-card-actions style="height:52px; !important">
        <v-chip v-if="rattache" color="primary" data-testid="statut-rattachement"> Rattaché </v-chip>
        <v-chip v-if="rattachementEnCours" color="primary" data-testid="statut-rattachement">
          Rattachement en cours
        </v-chip>
        <template v-if="numerisationEnCours">
          <v-spacer />
          <v-chip color="info" data-testid="statut-numerisation"> Numérisation en cours </v-chip>
        </template>
      </v-card-actions>
    </v-card>
  </v-hover>
</template>

<script>
import { toDetailAssociation } from "@/routes/associations";
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    validation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogInvitation: false,
      dialogRattachement: false,
    };
  },
  methods: {
    versAssociation() {
      this.$router.push(this.routeAssociation);
    },
    procedureRattachement() {
      if (this.invitation) {
        this.dialogInvitation = true;
      }
    },
    validationInvitation(valide) {
      this.$emit("invitation", { numero: this.association.numero, valide });
    },
  },
  computed: {
    routeAssociation() {
      return toDetailAssociation(this.association.numero);
    },
    association() {
      return this.value.association;
    },
    rattachementEnCours() {
      return "EN_COURS" === this.value.rattachement;
    },
    rattache() {
      return "RATTACHE" === this.value.rattachement;
    },
    invitation() {
      return !!this.value.invitation;
    },
    gestion() {
      return !!this.value.invitation?.gestion;
    },
    depot() {
      return !!this.value.invitation?.depot;
    },
    labelDemandeur() {
      return this.demandeur || "le greffe du registre des associations";
    },
    demandeur() {
      return this.value.invitation?.identite;
    },
    numerisationEnCours() {
      return ["EN_COURS_ATTACHE", "EN_COURS"].includes(this.value.numerisation);
    },
  },
};
</script>
